import { render, staticRenderFns } from "./create-to-body.vue?vue&type=template&id=0797a544"
import script from "./create-to-body.vue?vue&type=script&lang=js"
export * from "./create-to-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0797a544')) {
      api.createRecord('0797a544', component.options)
    } else {
      api.reload('0797a544', component.options)
    }
    module.hot.accept("./create-to-body.vue?vue&type=template&id=0797a544", function () {
      api.rerender('0797a544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/create-to-body.vue"
export default component.exports